import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/new/31.png';
import _imports_1 from '../../../assets/new/35.png';
import _imports_2 from '../../../assets/new/36.png';
import _imports_3 from '../../../assets/new/37.png';
import _imports_4 from '../../../assets/new/38.png';
import _imports_5 from '../../../assets/new/49.png';
import _imports_6 from '../../../assets/new/9.png';
import _imports_7 from '../../../assets/new/51.png';
const _withScopeId = n => (_pushScopeId("data-v-78827d36"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  class: "filter"
};
const _hoisted_5 = {
  class: "selects"
};
const _hoisted_6 = {
  key: 0,
  src: _imports_1
};
const _hoisted_7 = {
  key: 1,
  src: _imports_2
};
const _hoisted_8 = {
  key: 0,
  src: _imports_1
};
const _hoisted_9 = {
  key: 1,
  src: _imports_2
};
const _hoisted_10 = {
  class: "list"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "难度：", -1));
const _hoisted_13 = {
  key: 0,
  class: "page"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
const _hoisted_15 = [_hoisted_14];
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));
const _hoisted_17 = [_hoisted_16];
const _hoisted_18 = {
  key: 0,
  style: {
    "height": "6rem"
  }
};
const _hoisted_19 = {
  class: "footer"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5
}, null, -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6
}, null, -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7
}, null, -1));
import { ref, reactive, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
import { getLocalPid } from "../../../libs/util";
import { articleSearch, articleSubjects } from "../../../api/index";
export default {
  __name: 'search_copy',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const pid = getLocalPid();
    const router = useRouter();
    const articleData = reactive({
      data: {}
    });
    const gradeName = ref("");
    const subjectName = ref("");
    const searchParams = reactive({
      grade: "",
      subject: "",
      pageSize: 6,
      pageIdx: 0
    });
    const store = useStore();
    const token = computed(() => store.state.token);
    const userId = computed(() => store.state.userId);
    const sign = computed(() => store.state.sign);
    const grades = [{
      name: "全部",
      value: ""
    }, {
      name: "小一上 (0起点)",
      value: "X1s"
    }, {
      name: "小一下",
      value: "X1x"
    }, {
      name: "小二上",
      value: "X2s"
    }, {
      name: "小二下",
      value: "X2x"
    }, {
      name: "小三上",
      value: "X3s"
    }, {
      name: "小三下",
      value: "X3x"
    }, {
      name: "小四上",
      value: "X4s"
    }, {
      name: "小四下",
      value: "X4x"
    }, {
      name: "小五上",
      value: "X5s"
    }, {
      name: "小五下",
      value: "X5x"
    }, {
      name: "小六上",
      value: "X6s"
    }, {
      name: "小六下",
      value: "X6x"
    }, {
      name: "初一上",
      value: "C1s"
    }, {
      name: "初一下",
      value: "C1x"
    }, {
      name: "初二上",
      value: "C2s"
    }, {
      name: "初二下",
      value: "C2x"
    }, {
      name: "初三上",
      value: "C3s"
    }, {
      name: "初三下",
      value: "C3x"
    }, {
      name: "高一上",
      value: "G1s"
    }, {
      name: "高一下",
      value: "G1x"
    }, {
      name: "高二上",
      value: "G2s"
    }, {
      name: "高二下",
      value: "G2x"
    }, {
      name: "高三上",
      value: "G3s"
    }, {
      name: "高三下",
      value: "G3x"
    }, {
      name: "大一上",
      value: "B1s"
    }, {
      name: "大一下",
      value: "B1x"
    }, {
      name: "大二上",
      value: "B2s"
    }, {
      name: "大二下",
      value: "B2x"
    }, {
      name: "大三上",
      value: "B3s"
    }, {
      name: "大三下",
      value: "B3x"
    }, {
      name: "大四上",
      value: "B4s"
    }, {
      name: "大四下",
      value: "B4x"
    }, {
      name: "研一上",
      value: "Y1s"
    }, {
      name: "研一下",
      value: "Y1x"
    }, {
      name: "研二上",
      value: "Y2s"
    }, {
      name: "研二下",
      value: "Y2x"
    }, {
      name: "研三上",
      value: "Y3s"
    }, {
      name: "研三下",
      value: "Y3x"
    }, {
      name: "研四上",
      value: "Y4s"
    }, {
      name: "研四下",
      value: "Y4x"
    }];
    const subjects = reactive({
      data: []
    });
    const gradesFieldName = {
      text: "name"
    };
    const subjectFieldName = {
      text: "name"
    };
    const searchAll = () => {
      searchParams.pageIdx = 0;
      searchParams.grade = "";
      searchParams.subject = "";
      searchArticles();
    };
    const navTo = id => {
      router.push({
        name: "article",
        query: {
          id,
          pid
        }
      });
    };
    const searchArticles = () => {
      let obj = {
        userId: userId.value,
        token: token.value,
        sign: sign.value,
        pid: getLocalPid(),
        ...searchParams
      };
      articleSearch(JSON.stringify(obj)).then(res => {
        articleData.data = res.data.data;
      }).catch(() => {
        ElMessage.error("获取文章列表失败 请稍后再试");
      });
    };
    const loadSubjects = () => {
      let obj = {
        userId: userId.value,
        token: token.value,
        sign: sign.value,
        pid: getLocalPid()
      };
      articleSubjects(JSON.stringify(obj)).then(res => {
        subjects.data = [{
          name: "全部",
          value: ""
        }].concat(res.data.data.map(item => {
          return {
            name: item,
            value: item
          };
        }));
        console.log(subjects.data);
      }).catch(() => {
        ElMessage.error("获取文章主题列表失败 请稍后再试");
      });
    };
    const onBtnClickPrevPage = () => {
      searchParams.pageIdx--;
      if (searchParams.pageIdx < 0) searchParams.pageIdx = 0;
      searchArticles();
    };
    const onBtnClickNextPage = () => {
      searchParams.pageIdx++;
      searchArticles();
    };
    const gradesPicker = ref(false);
    const subjectPicker = ref(false);
    const onSelectChangedGrade = data => {
      searchParams.pageIdx = 0;
      searchParams.grade = data.value;
      gradeName.value = data.name;
      searchArticles();
      gradesPicker.value = false;
    };
    const onSelectChangedSubject = data => {
      searchParams.pageIdx = 0;
      searchParams.subject = data.value;
      subjectName.value = data.name;
      searchArticles();
      subjectPicker.value = false;
    };
    onMounted(async () => {
      loadSubjects();
      searchArticles();
    });
    return (_ctx, _cache) => {
      const _component_van_rate = _resolveComponent("van-rate");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass([isMobile.value ? 'container' : 'containerPc'])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).go(-1))
      }, _hoisted_3), _createTextVNode(" 所有文章 ")]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
        type: "button",
        class: _normalizeClass({
          active: searchParams.grade || gradesPicker.value === true
        }),
        onClick: _cache[1] || (_cache[1] = $event => gradesPicker.value = true)
      }, [_createTextVNode(_toDisplayString(searchParams.grade ? gradeName.value : "年级") + " ", 1), searchParams.grade || gradesPicker.value === true ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : (_openBlock(), _createElementBlock("img", _hoisted_7))], 2), _createElementVNode("button", {
        type: "button",
        class: _normalizeClass({
          active: searchParams.subject || subjectPicker.value === true
        }),
        onClick: _cache[2] || (_cache[2] = $event => subjectPicker.value = true)
      }, [_createTextVNode(_toDisplayString(searchParams.subject ? subjectName.value : "主题") + " ", 1), searchParams.subject || subjectPicker.value === true ? (_openBlock(), _createElementBlock("img", _hoisted_8)) : (_openBlock(), _createElementBlock("img", _hoisted_9))], 2)]), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: searchAll
      }, "全部")]), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articleData.data.recommendArticles, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          onClick: $event => navTo(item.articleId),
          key: index
        }, [_createElementVNode("h4", null, _toDisplayString(item.title), 1), _createElementVNode("div", null, [_hoisted_12, _createVNode(_component_van_rate, {
          modelValue: item.levelStar,
          "onUpdate:modelValue": $event => item.levelStar = $event,
          color: "#3FABFA",
          readonly: ""
        }, null, 8, ["modelValue", "onUpdate:modelValue"])])], 8, _hoisted_11);
      }), 128)), articleData.data.recommendArticles && articleData.data.recommendArticles.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: onBtnClickPrevPage
      }, _hoisted_15), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: onBtnClickNextPage
      }, _hoisted_17)])) : _createCommentVNode("", true)]), isMobile.value ? (_openBlock(), _createElementBlock("div", _hoisted_18)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push({
          name: 'index',
          query: {
            pid: _unref(pid)
          }
        }))
      }, [_hoisted_20, _createTextVNode(" 原版阅读 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
          name: 'photo',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_21, _createTextVNode(" AI工具 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        style: {
          "color": "#35b9ff"
        },
        onClick: _cache[5] || (_cache[5] = $event => _unref(router).push({
          name: 'my',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_22, _createTextVNode(" 个人中心 ")])])], 2), _createVNode(_component_van_popup, {
        show: gradesPicker.value,
        "onUpdate:show": _cache[7] || (_cache[7] = $event => gradesPicker.value = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          columns: grades,
          "columns-field-names": gradesFieldName,
          onCancel: _cache[6] || (_cache[6] = $event => gradesPicker.value = false),
          onConfirm: onSelectChangedGrade
        })]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: subjectPicker.value,
        "onUpdate:show": _cache[9] || (_cache[9] = $event => subjectPicker.value = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          columns: subjects.data,
          "columns-field-names": subjectFieldName,
          onCancel: _cache[8] || (_cache[8] = $event => subjectPicker.value = false),
          onConfirm: onSelectChangedSubject
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};